import { isAuthenticated } from './guardService';

export default async (to) => {
    if (!to.meta.requiresAuth || isAuthenticated()) {
        return true;
    }

    const params = location.search.substring(1)
        .split("&")
        .filter(p => !['reason', 'lang'].includes(p.split('=')[0]))
        .join("&");

    const currentPath = location.pathname.substring(1) + (params.length ? `?${params}` : '');

    return {
        name: 'login',
        query: {
            path: currentPath,
            reason: to.query.reason,
            lang: to.query.lang
        }
    };
};
